import React from 'react';
import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import { ContainerDetailsModel } from 'src/components/common/container-details/ContainerDetailsModel';
import { getContainerIdString } from 'src/data-map/containerDetailsToStringID';
import * as AppStrings from 'src/localization/string-ids/app-strings';

interface JackpotScanLpnItemsTableProps {
    scannedItems: ContainerDetailsModel[];
    dataTestId?: string;
}

class JackpotScanLpnItemsTable extends React.Component<JackpotScanLpnItemsTableProps> {

    private properties = [
        { key: 'sortationCategories', label: AppStrings.SEARCH_TABLE_SORTATION_CATEGORY },
        { key: 'containerProperties.cleanDecantDate', label: AppStrings.SEARCH_TABLE_CDD },
        { key: 'latestProcessingDate', label: AppStrings.SEARCH_TABLE_LPD },
        { key: 'sla', label: AppStrings.SEARCH_TABLE_SLA },
        { key: 'containerProperties.RMAId', label: AppStrings.SEARCH_TABLE_RMA_ID },
        { key: 'containerProperties.Asin', label: AppStrings.SEARCH_TABLE_ASIN },
        { key: 'containerProperties.cleanDecantSortRuleId', label: AppStrings.SEARCH_TABLE_RULE_ID },
        { key: 'containerProperties.SellerType', label: AppStrings.SEARCH_TABLE_SELLER_TYPE },
        { key: 'containerProperties.TTSorTTA', label: AppStrings.SEARCH_TABLE_TTS_OR_TTA },
        { key: 'containerProperties.requiredHazmatLabels', label: AppStrings.SEARCH_TABLE_HAZMAT_LABELS },
        { key: 'latestContainerOperation.name', label: AppStrings.SEARCH_TABLE_LATEST_CONTAINER_OPERATION_NAME },
        { key: 'latestContainerOperation.time', label: AppStrings.SEARCH_TABLE_LATEST_CONTAINER_OPERATION_TIME },
        { key: 'latestContainerOperation.associate', label: AppStrings.SEARCH_TABLE_LATEST_CONTAINER_OPERATION_ASSOCIATE },
        { key: 'containerProperties.routingDestination', label: AppStrings.SCAN_ITEM_TABLE_ROUTING_DESTINATION }
    ];

    private getPropertyValue = (item: ContainerDetailsModel, key: string): unknown => {
        return key.split('.').reduce((acc: any, cur) => acc?.[cur], item);
    }

    private getVisibleProperties = () => {
        return this.properties.filter(({key}) =>
            this.props.scannedItems.some(item => {
                const value = this.getPropertyValue(item, key);
                return Array.isArray(value) ? value.length > 0 : !!value;
            })
        );
    }

    private renderTitleRow = () => {
        return (
            <TableRow>
                <TableCell columnSpan={this.getVisibleProperties().length + 1}>
                    {this.props.scannedItems[0]?.containerType} Information
                </TableCell>
            </TableRow>
        );
    }

    private renderHeaderRow = () => {
        return (
            <TableRow>
                <TableCell>{getContainerIdString(this.props.scannedItems[0]?.containerType)}</TableCell>
                {this.getVisibleProperties().map(({key, label}) => (
                    <TableCell key={key}>{label}</TableCell>
                ))}
            </TableRow>
        );
    }

    private renderItemRow = (item: ContainerDetailsModel) => {
        return (
            <TableRow key={item.containerId}>
                <TableCell>{item.containerId}</TableCell>
                {this.getVisibleProperties().map(({key}) => {
                    const value = this.getPropertyValue(item, key);
                    if (key === 'sortationCategories' && Array.isArray(value)) {
                        return <TableCell key={key}>{value.join(', ')}</TableCell>;
                    }
                    return <TableCell key={key}>{value ? String(value) : ''}</TableCell>;
                })}
            </TableRow>
        );
    }

    public render() {
        if (this.props.scannedItems.length === 0) {
            return null;
        }

        return (
            <div className="scan-lpn-table-container">
                <Table headerRows={2} showDividers={true} spacing="small" className="scan-lpn-table" data-testid={this.props.dataTestId ?? "jackpot-scan-lpn-items-table"}>
                    {this.renderTitleRow()}
                    {this.renderHeaderRow()}
                    {this.props.scannedItems.map(this.renderItemRow)}
                </Table>
            </div>
        );
    }
}

export default JackpotScanLpnItemsTable;
